import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import RoomContext from '../../services/roomContext';
import {
  Token,
  TwilioConnect,
  VideoNBoxChatToken,
} from '../../services/twilioServices';
import { updateChatSid } from '../../redux/boxChatSlice';
// import DotLoader from '../loaders/dotLoader';
import StreamSkeleton from '../loaders/StreamSkeleton';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

function RoomConnectPrep({
  boxRoomName,
  username,
  url,
  boxChatSid,
  eventLayoutURL,
  participantName,
  userId,
  eventId,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [rooms, setRooms] = useState({
    activeGConversation: null,
    activeBConversation: null,
    activeBoxRoom: null,
    globalParticipants: [],
    boxParticipants: [],
  });

  useEffect(() => {
    //connect to box room
    handleTwilioConnect(
      userId,
      boxRoomName,
      TwilioConnect,
      'activeBoxRoom',
      'activeBoxDataTrack',
      'boxParticipants',
      boxChatSid,
      participantName
    );
  }, []);

  const handleTwilioConnect = async (
    userId,
    roomName,
    connectRoom,
    activeRoom,
    activeDataTrack,
    participants,
    chatSID,
    participantName
  ) => {
    // console.log(chatSID, 'here it is origin')
    // const token = await Token(userId, roomName, chatSID, participantName);
    const [videoToken, boxChatToken] = await VideoNBoxChatToken(
      userId,
      roomName,
      chatSID,
      participantName
    );
    if (videoToken && boxChatToken) {
      const twilioConnect = await connectRoom(videoToken, roomName);
      dispatch(
        updateChatSid({ boxChatToken: boxChatToken, boxChatSid: boxChatSid })
      );
      if (twilioConnect?.success) {
        setRooms((prevState) => {
          return {
            ...prevState,
            [activeRoom]: twilioConnect.room,
          };
        });
      } else {
        console.log('There is some error', twilioConnect.error);
        history.push('/');
      }
    } else {
      history.push('/');
    }
  };

  const wrapContext = () => {
    return (
      <RoomContext.Provider value={{ rooms: rooms, setRooms: setRooms }}>
        <Layout
          url={url}
          eventLayoutURL={eventLayoutURL}
          userId={userId}
          eventId={eventId}
        />
      </RoomContext.Provider>
    );
  };

  const renderLoader = () => {
    return <StreamSkeleton />;
  };

  const renderFunc = () => {
    const layout = rooms?.activeBoxRoom ? wrapContext() : renderLoader();
    return layout;
  };

  return renderFunc();
}

export default RoomConnectPrep;
